import React, { useEffect, useState } from 'react';

import moment from 'moment';

function VenueSchedules({ schedules, date }) {
    return (
        <div className="venue-schedules mb-3">
            {schedules.length ? (
                <>
                    <VenueSchedule />
                    {schedules.map((schedule, i) => (
                        <VenueSchedule schedule={schedule} key={schedule.id.toString()} />
                    ))}
                </>
            ) : (
                <NoSchedules />
            )}
        </div>
    );
}

export default VenueSchedules;
const NoSchedules = () => {
    return <p className="tw-text-sm tw-text-charcoal-50">{$t('No sessions on the selected day')}</p>;
};

const VenueSchedule = ({ schedule }) => {
    const [times, setTimes] = useState(false);
    useEffect(() => {
        if (schedule) {
            const start = moment(schedule.start);
            const end = moment(schedule.end);
            const duration = moment.utc(end.diff(start)).format('HH:mm');
            setTimes({
                start: start.format('DD/MM/YY HH:mm'),
                end: end.format('DD/MM/YY HH:mm'),
                duration: duration,
            });
        }
    }, []);
    return (
        <div className="tw-grid tw-grid-cols-4 tw-gap-2">
            <div className="tw-col-auto">
                {schedule ? <span>{schedule.title}</span> : <span className="tw-text-xs tw-text-charcoal">{$t('Session Name')}</span>}
            </div>
            <div className="tw-col-auto">{schedule ? <span>{times.start}</span> : <span className="tw-text-xs tw-text-charcoal">{$t('Start')}</span>}</div>
            <div className="tw-col-auto">{schedule ? <span>{times.end}</span> : <span className="tw-text-xs tw-text-charcoal">{$t('End')}</span>}</div>
            <div className="tw-col-auto">
                {schedule ? <span>{times.duration}</span> : <span className="tw-text-xs tw-text-charcoal">{$t('Duration')}</span>}
            </div>
        </div>
    );
};
